import type { ColorValue } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";

export const DEFAULT_COLOR: ColorValue = {
  rgb: { r: 100, g: 100, b: 200, a: 1 },
};

export const colorPickerNode: NodeDefinition = {
  type: "colorPicker",
  label: "Color Picker",
  category: "Style",
  width: 240,
  inputs: [],
  outputs: [{ key: "color", label: "Color", socket: "color" }],
  controls: [{ kind: "color", key: "color" }],
  defaults: { color: DEFAULT_COLOR },

  compute(ctx) {
    return {
      color: (ctx.data["color"] as ColorValue | undefined) ?? DEFAULT_COLOR,
    };
  },
};
